import React from 'react';

interface SEOProps {
    title?: string;
    description?: string;
    keywords?: string;
    name?: string;
    type?: string;
    schema?: object;
    canonical?: string;
    image?: string;
    noindex?: boolean;
}

const SEO: React.FC<SEOProps> = ({
    title,
    description,
    keywords,
    name = "Solunn",
    type = "website",
    schema,
    canonical,
    image = "https://solunn.com/og-image.png",
    noindex = false
}) => {
    return (
        <>
            {/* Standard Metadata */}
            {title && <title>{title}</title>}
            {title && <meta name="title" content={title} />}
            {description && <meta name="description" content={description} />}
            {keywords && <meta name="keywords" content={keywords} />}
            {noindex && <meta name="robots" content="noindex, nofollow" />}
            {canonical && <link rel="canonical" href={canonical} />}

            {/* Open Graph */}
            {type && <meta property="og:type" content={type} />}
            <meta property="og:site_name" content={name} />
            {title && <meta property="og:title" content={title} />}
            {description && <meta property="og:description" content={description} />}
            {image && <meta property="og:image" content={image} />}

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            {title && <meta name="twitter:title" content={title} />}
            {description && <meta name="twitter:description" content={description} />}
            {image && <meta name="twitter:image" content={image} />}

            {/* Structured Data */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </>
    );
};

export default SEO;

